<template>
  <div class="prize-item" >
    <div class="prize-item-img-container" :class="{'bought-filter': item.bought}">
      <div class="prize-item-img" :class="getClass" ref="prizeItemImg" @click="handleShowPrizeName">
        <img :src="item.item_img" alt="prize"  />
        <PrizeNum :num="item.item_num" />
      </div>
      <div class="prize-item-img-light" v-show="!item.bought" :class="getLightClass"></div>
    </div>
    <div class="prize-item-price">
      <div class="prize-item-price-discount">
        <span class="diamond" :class="{'diamond-disabled': item.bought}"></span>
        <span
          class="prize-item-price-discount-value"
          :class="{'bought-text': item.bought}"
        >{{ getPrice(item) }}</span>
      </div>
      <div class="prize-item-price-origin" v-show="discount < 100 && discount > 0">
        <span class="diamond" :class="{'diamond-disabled': item.bought}"></span>
        <span
          class="prize-item-price-origin-value"
          :class="{'bought-text': item.bought}"
        >{{ item.price }}</span>
        <span class="del" :class="{'bought-filter': item.bought}"></span>
      </div>
    </div>
    <div v-if="item.bought" class="purchase-item-bought">{{ $bus.transify['FESTA_PURCHASED'] }}</div>
    <PurchaseButton
      v-else
      :disabled="$bus.isFirst"
      :bought="item.bought"
      @purchase="handlePurchase(item)"
      :id="item.pk"
    />
    <PrizeName :name="item.item_name" :pos="pos" v-show="getShow" :class="{'bought-filter': item.bought}" />
  </div>
</template>

<script>
import PurchaseButton from '@/components/business-base/purchase-button'
import PrizeName from '@/components/business-base/prize-name'
import PrizeNum from '@/components/business-base/prize-num'
import { addGA } from '@/utils/assist'

export default {
  components: {
    PurchaseButton,
    PrizeName,
    PrizeNum
  },
  props: {
    item: {
      type: Object,
      default: () => ({})
    },
    discount: {
      type: Number,
      default: 0
    },
    pos: Number
  },
  data () {
    return {
      timer: null,
      showPrizeName: false
    }
  },
  computed: {
    getClass () {
      return `prize-item-img-${this.$bus.shopType}`
    },
    getLightClass () {
      return {
        [`prize-item-img-${this.$bus.shopType}-light`]: this.$bus[`inuse${this.$bus.shopType}`]
      }
    },
    getShow () {
      return this.showPrizeName && this.$bus.activeIndex === this.pos
    }
  },
  methods: {
    getPrice (item) {
      const index = this.$bus.mapShopTypeToDiscount(this.$bus.shopType)
      let discount = this.discount
      if (item.bought) {
        discount = this.$bus.discount[index]
      }
      const currentDiscount = item.bigBoughtDiscount > 0 ? item.bigBoughtDiscount : discount
      return Math.floor(item.price * (100 - currentDiscount) / 100)
    },
    handleShowPrizeName () {
      addGA('show-prize-name', 'click')
      if (this.$bus.isFirst) {
        return
      }
      this.showPrizeName = !this.showPrizeName
      this.$bus.activeIndex = this.pos
    },
    handlePurchase (item) {
      const price = Math.floor(item.price * (100 - this.$bus.currentDiscount) / 100)
      if (this.$bus.checkGem(price)) {
        this.$bus.spendDialogShow = true
        this.$bus.prize = item
      } else {
        this.$bus.toast = {
          show: true,
          content: this.$bus.transify['TOAST_GEM_NOT_ENOUGH'] ? this.$bus.transify['TOAST_GEM_NOT_ENOUGH'] : 'TOAST_GEM_NOT_ENOUGH',
          closeable: true
        }
      }
    }
  },
  watch: {
    getShow (current) {
      if (current) {
        clearTimeout(this.timer)
        this.timer = setTimeout(() => {
          this.showPrizeName = false
        }, 3000)
      } else {
        this.showPrizeName = false
        clearTimeout(this.timer)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.prize-item {
  position: relative;
  display: inline-block;
  @include px2res(padding, 8, 10);
  @include px2res(width, 198);

  .bought-text {
    color: #b2b2b2;
  }

  .prize-item-img-container {
    position: relative;
    @include px2res(width, 146);
    @include px2res(height, 141);
    margin: 0 auto;

    &.bought-filter {
      filter: grayscale(100%);
    }

    .prize-item-img {
      position: absolute;
      top: 0;
      left: 0;
      @include flexrc;
      width: 100%;
      height: 100%;

      img {
        max-width: 75%;
        max-height: 75%;
      }
    }

    .prize-item-img-light {
      position: absolute;
      @include px2res(top, -19);
      @include px2res(left, -19);
      @include px2res(width, 184);
      @include px2res(height, 179);
      z-index: -1;
    }
  }

  .prize-item-price {
    @include flexjc;
    align-items: flex-end;
    @include px2res(margin, 8, 0);

    .prize-item-price-discount {
      @include flexac;

      .diamond {
        @include px2res(width, 30);
        @include px2res(height, 27);
      }

      .prize-item-price-discount-value {
        @include px2res(padding, 0, 3);
        @include px2res(font-size, 40);
      }
    }

    .prize-item-price-origin {
      position: relative;
      @include flexac;

      .diamond {
        @include px2res(width, 22);
        @include px2res(height, 20);
      }

      .prize-item-price-origin-value {
        @include px2res(font-size, 29);
      }

      .del {
        position: absolute;
        left: 0;
        top: 50%;
        transform: translateY(-50%);
        width: 100%;
        height: 2px;

        &.bought-filter {
          filter: grayscale(100%);
        }
      }
    }
  }

  .purchase-item-bought {
    @include flexrc;
    @include px2res(width, 178);
    @include px2res(height, 71);
    font-weight: 300;
    @include px2res(font-size, 34);
    color: #8b8b8b;
    font-family: $main-font-family;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/shop/prize-item.vue